module.exports = __webpack_public_path__ + "img/basketball-category-icon-red.ea2bb395.png";